import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class AiCriteria extends BasicCriteria {
bytes: string;
fileKind: string;
locale: string;
max_tokens: number | null;
prompt: string;
questionCode: string;
summarize: boolean;
systemPrompt: string;
temperature: number | null;
visionCode: string;
}

